// HESTON App Exports
import HestonApp from './HestonApp';
import ProjectDetail from './pages/ProjectDetail';
import ProjectPrices from './pages/ProjectPrices';

// Export Dashboard as the main component (Project List)
export const Dashboard = HestonApp;

// Project Dashboard Workspace (Addresses + Analytics)
export const ProjectDetailPage = ProjectDetail;

// Pricing Simulator Standalone Page
export const ProjectPricesPage = ProjectPrices;
